import React from 'react';
import { Button, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useKeycloak } from '../../../auth/KeycloakProvider';
import UserAvatar from '../UserAvatar';
import { useTranslation } from '../../../utils';
import './LogoutDropdown.scss';

const LogoutDropdown: React.FC = () => {
  const { keycloak } = useKeycloak();
  const translate = useTranslation();
  const logoutUser = () => {
    keycloak.logout();
  };

  const menuItems = [
    {
      key: '0',
      label: translate('form.logout'),
      onClick: logoutUser,
    },
  ];

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={['click']}
      placement="bottomLeft"
      className="user-dropdown"
    >
      <Button>
        <UserAvatar
          firstName={keycloak.profile?.firstName || ''}
          lastName={keycloak.profile?.lastName || ''}
        />
        {keycloak.profile?.firstName || (keycloak.profile?.email || '').split('@')[0]}
        <DownOutlined />
      </Button>
    </Dropdown>
  );
};

export default LogoutDropdown;
